// Tab order is the wireframe's, with Metrics added sixth (Loom 2026-09-20, Sam 0:39).
// Shared by the route config and the shell so a tab cannot exist in one and not the other.
// The gateway answers `clone_not_available` (503) until voice cloning ships. Flip to re-enable
// the Clone tab, its route and the "Clone a voice" link.
export const CLONE_ENABLED = false

const ALL_TABS = [
  { key: 'explore', label: 'Explore' },
  { key: 'voices', label: 'Voices' },
  { key: 'lexicons', label: 'Lexicons' },
  { key: 'clone', label: 'Clone' },
  { key: 'metrics', label: 'Metrics' },
] as const

export type VoiceStudioTabKey = (typeof ALL_TABS)[number]['key']

export const VOICE_STUDIO_TABS = ALL_TABS.filter((tab) => CLONE_ENABLED || tab.key !== 'clone')

export const DEFAULT_VOICE_STUDIO_TAB: VoiceStudioTabKey = 'explore'

export const resolveVoiceStudioTab = (pathname: string): VoiceStudioTabKey => {
  const last = pathname.split('/').filter(Boolean).pop()
  const match = VOICE_STUDIO_TABS.find((tab) => tab.key === last)
  return match ? match.key : DEFAULT_VOICE_STUDIO_TAB
}
